"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateHeaderAccountMenuItems = void 0;
/**
 * @internal
 */
function generateHeaderAccountMenuItems(workspacePermissions, // bootstrapResource.current.projectPermissions
uiSettings, // bootstrapResource.settings
workspaceId, // parsed from bootstrapResource.current.project.links.self
showOnlyLogoutItem, featureFlags) {
    var canInitData = workspacePermissions.canInitData;
    var displayAccountPage = uiSettings.displayAccountPage;
    var accountMenuItems = [];
    var workspaceRef = (featureFlags === null || featureFlags === void 0 ? void 0 : featureFlags.enableRenamingProjectToWorkspace) ? "workspaces" : "projects";
    var accountItem = {
        key: "gs.header.account",
        className: "s-account",
        href: "/#s=/gdc/" + workspaceRef + "/" + workspaceId + "|accountPage|",
    };
    var dataIntegrationConsoleItem = {
        key: "gs.header.dic",
        className: "s-dic",
        href: "/admin/disc/",
    };
    var logoutItem = {
        key: "gs.header.logout",
        className: "s-logout",
    };
    var showAccountItem = workspaceId && displayAccountPage && !showOnlyLogoutItem;
    var showDataIntegrationConsoleItem = canInitData === true && !showOnlyLogoutItem;
    if (showAccountItem) {
        accountMenuItems.push(accountItem);
    }
    if (showDataIntegrationConsoleItem) {
        accountMenuItems.push(dataIntegrationConsoleItem);
    }
    accountMenuItems.push(logoutItem);
    return accountMenuItems;
}
exports.generateHeaderAccountMenuItems = generateHeaderAccountMenuItems;
//# sourceMappingURL=generateHeaderAccountMenuItems.js.map